module.exports = __webpack_public_path__ + "img/logo_mini_light.5ace0c41.svg";